var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Heading", {
        attrs: {
          title: _vm.$t("about") + " " + _vm.capitalize(_vm.$t("site_tpf")),
          routeName: "vignette",
        },
      }),
      _c("AboutPeajContent"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }